import {
    FIND_CONTACTS_URL,
    FIND_ROLES,
    NEW_MESSAGE_URL,
    GET_USERS_BY_IDS,
    GET_USER_THREADS,
    GET_USER_DRAFT_ANNOUNCEMENTS,
    SEND_MESSAGE_URL,
    UPLOAD_ATTACHMENTS,
} from './urls';

import getRolesTransformer from '../transforms/getRoles/getRoles';
import { findContactsTransformer } from '../transforms/findContacts/findContacts';
import { outboundConversationTransformer } from '../transforms/conversation/conversation';
import { getUsersByIDsTransformer } from '../transforms/getUsersByIDs/getUsersByIDs';
import { syncThreadsTransformer } from '../transforms/syncThreads/syncThreads';
import { draftAnnouncementsTransformer } from '../transforms/draftAnnouncements/draftAnnouncements';
import { outboundMessageTransformer } from '../transforms/messages/messages';
import { uploadAttachmentTransformer } from '../transforms/uploadAttachment/uploadAttachment';

export const inboundTransformConfig = {
    [FIND_CONTACTS_URL]: findContactsTransformer,
    [GET_USERS_BY_IDS]: getUsersByIDsTransformer,
    [GET_USER_THREADS]: syncThreadsTransformer,
    [GET_USER_DRAFT_ANNOUNCEMENTS]: draftAnnouncementsTransformer,
    [UPLOAD_ATTACHMENTS]: uploadAttachmentTransformer,
    [FIND_ROLES]: getRolesTransformer,
};

export const outboundTransformConfig = {
    [NEW_MESSAGE_URL]: outboundConversationTransformer,
    [SEND_MESSAGE_URL]: outboundMessageTransformer,
};
